import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function NotFound() {
  useEffect(() => {
    AOS.init({ duration: 2000, once: true });
  }, []);

  return (
    <div className="flex items-center justify-center h-screen bg-gray-200">
      <div
        className="bg-gradient-to-b from-white to-gray-300 shadow-2xl rounded-lg p-10 max-w-lg text-center transform hover:scale-105 transition-transform duration-300 ease-in-out"
        data-aos="zoom-in"
      >
        <h1 className="text-9xl font-extrabold text-red-500 text-shadow-lg" data-aos="fade-up">
          404
        </h1>
        <h2 className="text-3xl font-bold text-gray-800 mt-4" data-aos="fade-up" data-aos-delay="200">
          Page Not Found
        </h2>
        <p className="text-gray-600 mt-2 mb-6" data-aos="fade-up" data-aos-delay="400">
          Sorry, the page you are looking for does not exist.
        </p>
        <a
          href="/"
          className="bg-blue-600 text-white px-6 py-3 rounded-full shadow-lg transform hover:bg-blue-800 transition-all duration-300 hover:scale-110"
          data-aos="fade-up"
          data-aos-delay="600"
        >
          Back to Home
        </a>
      </div>
    </div>
  );
}
